import styled from 'styled-components';

const calculatePercentage = (position: number, steps: number) => (100 / (steps - 1)) * position;

const HighlightBar = styled.div<{ steps: number; position: number }>`
  background-color: ${(props) => props.theme.colors.tertiaryVariant};
  background-image: linear-gradient(
    45deg,
    transparent 24%,
    ${(props) => props.theme.colors.tertiary} 25%,
    ${(props) => props.theme.colors.tertiary} 26%,
    transparent 27%,
    transparent 74%,
    ${(props) => props.theme.colors.tertiary} 75%,
    ${(props) => props.theme.colors.tertiary} 76%,
    transparent 77%,
    transparent
  );
  background-size: 10px 10px;
  background-repeat: repeat;
  border-radius: 12px ${(props) => (props.position === props.steps - 1 ? '12px 12px' : '0 0')} 12px;
  height: 24px;
  width: ${(props) => {
    const p = calculatePercentage(props.position, props.steps);
    return p === 100 ? p + '%' : `calc(${p}% + ${((24 * (p - 50)) / 100) * -1}px)`;
  }};
  transition: width 500ms;
`;

export default HighlightBar;
